"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Android_1 = __importDefault(require("../Icons/Android"));
var Apple_1 = __importDefault(require("../Icons/Apple"));
var TrustedShops_1 = __importDefault(require("../Icons/TrustedShops"));
var config = {
    awards: [
        {
            icon: TrustedShops_1.default,
            linkProps: {
                href: '//www.trustedshops.de/bewertung/info_X66C2B4D25F59D0BFDE77ED9A44863055.html',
                target: '_blank'
            },
            tooltip: {
                subText: 'VP erfüllt die Trusted Shops Qualitätskriterien und erhielt dort die Bewertung „sehr gut“.',
                text: 'Trusted Shop'
            },
            type: 'link'
        }
    ],
    columns: [
        {
            items: [
                {
                    linkProps: {
                        href: '//www.veepee.de/Vp4/Help/question.ashx?cypher=LoL0YT63i9hymbOpyYUuwA%3D%3D'
                    },
                    text: 'Wer sind wir?'
                },
                {
                    linkProps: {
                        href: '//www.veepee.de/Vp4/Help/question.ashx?cypher=xLqOggt6VcH2Ragg0kMExA%3D%3D'
                    },
                    text: 'Sicherheit'
                },
                {
                    linkProps: {
                        href: '//www.veepee.de/vp4/Help/question.ashx?cypher=p7G5/JYwaTz7PA44wpUM6A=='
                    },
                    text: 'Impressum'
                },
                {
                    linkProps: {
                        href: '//www.veepee.de/vp4/Help/question.ashx?cypher=p7G5/JYwaTz7PA44wpUM6A=='
                    },
                    text: 'Rechtliche hinweise'
                }
            ],
            title: 'Hilfe & Kontakt'
        },
        {
            items: [
                {
                    linkProps: {
                        href: '//www.veepee.de/cgv/de-DE/agb.pdf',
                        target: '_blank'
                    },
                    text: 'AGB'
                },
                {
                    linkProps: {
                        href: '//www.veepee.de/vp4/Help/question.ashx?cypher=2XPycfJE%2FvPFmqiNRsyC3g%3D%3D'
                    },
                    text: 'Datenschutz'
                }
            ],
            title: 'Allgemeine Geschäftsbegingungen'
        },
        {
            items: [
                {
                    linkProps: {
                        href: '//careers.veepee.com/vptech-2/',
                        target: '_blank'
                    },
                    text: 'vpTech'
                },
                {
                    linkProps: {
                        href: '//careers.veepee.com/en/home-page-en',
                        target: '_blank'
                    },
                    text: 'Veepee'
                }
            ],
            title: 'Join us'
        },
        {
            items: [],
            title: ''
        }
    ],
    country: 'DE',
    flag: 'DE',
    header: {
        apps: {
            items: [
                {
                    icon: Apple_1.default,
                    label: 'iOS',
                    linkProps: {
                        href: '//apps.apple.com/de/app/veepee-by-vente-privee/id906681058',
                        target: '_blank'
                    }
                },
                {
                    icon: Android_1.default,
                    label: 'Android',
                    linkProps: {
                        href: '//play.google.com/store/apps/details?id=com.venteprivee',
                        target: '_blank'
                    }
                }
            ],
            title: 'Our applications'
        },
        social: []
    },
    lang: 'de',
    logoSubtitle: 'VP, Aus Liebe zu Marken'
};
exports.default = config;
